// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../getWeeksInMonth/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var getWeeksInMonth = convertToFP(fn, 1);
export default getWeeksInMonth;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/getWeeksInMonth/index.js
// module id = 914
// module chunks = 0